import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { IRollbackPerformerProps } from './IRollbackPerformerProps';
import { RollbackPerformerModal } from './RollbackPerformerModal';

export const RollbackPerformerExecutor = createActivityModalExecutor<IRollbackPerformerProps>({
    modal: RollbackPerformerModal,
    defaultModalSize: 'm',
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        activityId: getActivityIdFromCompositeId(objId),
        actionKey: action.key,
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
